import React, { ComponentPropsWithoutRef } from 'react';
import Box from '../../components/Box/Box';
import Icon from '../../components/Icon/Icon';
import getComponentClassNames from '../../utils/className/getComponentClassNames';

const classNames = getComponentClassNames(['AccordionHeader'], ['content', 'expandToggleIcon']);

type TAccordionHeaderProps = ComponentPropsWithoutRef<'summary'>;

// eslint-disable-next-line react/prop-types
const AccordionHeader = ({ onClick, children, ...rest }: TAccordionHeaderProps) => (
  <Box {...rest} onClick={onClick} as="summary" parent="AccordionItem" name="accordionHeader">
    <div className={classNames.content}>{children}</div>
    <Icon name="arrow-down" className={classNames.expandToggleIcon} />
  </Box>
);

export default AccordionHeader;
